module.exports = __webpack_public_path__ + "static/media/iconfinder_ic_highlight_remove_48px_352425.715b6757.svg";